import { Link } from 'react-router-dom'
import * as React from 'react'
import LinkIcon from './LinkIcon'

interface Props {
  icon: React.ComponentClass<IconProps>
  url: string
  text: React.ReactNode
}

export default function NavigationLink(props: Props) {
  return (
    <li key={props.url} className="list-group-item">
      <Link to={props.url}>
        <LinkIcon icon={props.icon} />
        {props.text}
      </Link>
    </li>
  )
}
